import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import Orders from "./Orders";
import ReadyToShipOrders from "./ReadyToShipOrders";
import InTransitOrders from "./InTransitOrders";
import DeliveredOrders from "./DeliveredOrders";
import CancelledOrder from "./CancelledOrder";
import AllOrder from "./AllOrder";
import { FaUpload, FaBars } from "react-icons/fa";
import axios from "axios";
import { ChevronDown } from "lucide-react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import BulkUploadPopup from "./BulkUploadPopup";



import RTO from "./RTO"
import OutForDelivery from "./OutForDelivery";
import RTOIntransit from "./RTOIntransit";
import RTODelivered from "./RTODelivered";
import RTOLost from "./RTOLost";
import RTODamaged from "./RTODamaged";
import Lost from "./Lost";
import Damaged from "./Damaged";
const OrdersPage = () => {

  const desktopDropdownRef = useRef(null);
  // console.log("ewwew",activeTab)
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const [upload, setUpload] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [orders, setOrders] = useState([]);
  const [showMoreTabs, setShowMoreTabs] = useState(false);

  const [showFilters, setShowFilters] = useState(false);

  const [orderIds, setOrderIds] = useState("");
  const [awbNumbers, setAwbNumbers] = useState("");
  const [productName, setProductName] = useState("");
  const [channel, setChannel] = useState("");
  const [type, setType] = useState("");
  const [courier, setCourier] = useState("");
  const [warehouse, setWarehouse] = useState("");
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [showCustomCalendar, setShowCustomCalendar] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [endDate, setEndDate] = useState(null);
  const [dateFilter, setDateFilter] = useState(""); // Add this line
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const [warehouseCities, setWarehouseCities] = useState([]);
  const [courierService, setCourierService] = useState([]);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const mobileDropdownRef = useRef(null);
  const location = useLocation()

  // const dropdownRef = useRef(null);
  const { id } = useParams();

  const tabs = [
    "New",
    "Ready to Ship",
    "In Transit",
    "Out for Delivery",
    "Delivered",

  ];
  const isNdrRoute = location.pathname === "dashboard/ndr";
  const tabStorageKey = isNdrRoute ? "activeNdrTab" : "activeOrderTab";

  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem(tabStorageKey) || "New";
  });

  useEffect(() => {
    localStorage.setItem(tabStorageKey, activeTab);
  }, [activeTab]);

  const moreTabs = ["Cancelled", "Lost", "Damaged", "RTO", "RTO In Transit", "RTO Delivered", "RTO Lost", "RTO Damaged", "All"];
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const toggleFilters = () => {
    if (filtersApplied) {
      // If filters are applied, clicking should only clear them (not open the panel)
      clearFilters();
      setFiltersApplied(false); // Remove red cross
    } else {
      // If no filters are applied, just toggle the filter section
      setShowFilters((prev) => !prev);
    }
  };

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const [session, token] = document.cookie.split("=");

        const response = await axios.get(
          `${REACT_APP_BACKEND_URL}/order/orders`,
          {
            headers: {
              authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("This is OrdersPage", response);
        setOrders(response.data.orders);
        setRefresh(false);
        const courierNames = [
          ...new Set(response.data.map((order) => order.courierServiceName)),
        ];

        setCourierService(courierNames);
        const cities = [
          ...new Set(response.data.map((order) => order.pickupAddress?.city)),
        ];
        setWarehouseCities(cities);
        // console.log(orders)
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };
    fetchOrders();
  }, [refresh]);

  const handleNewOrderClick = async () => {
    try {

      const [session, token] = document.cookie.split("=");

      const response = await axios.get(
        `${REACT_APP_BACKEND_URL}/users/getUsers`,
        {
          headers: { authorization: `Bearer ${token}` },
        }
      );

      if (response.data.isSeller) {
        navigate("/dashboard/order/neworder");
      } else {
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error fetching sellers:", error);
    }
  };
  // Apply Filters Logic
  const applyFilters = () => {
    let filteredOrders = [...orders];

    if (startDate && endDate) {
      filteredOrders = filteredOrders.filter((order) => {
        const orderDate = new Date(order.createdAt);
        const orderDateOnly = new Date(
          orderDate.getFullYear(),
          orderDate.getMonth(),
          orderDate.getDate()
        );

        const start = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
        const end = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

        return orderDateOnly >= start && orderDateOnly <= end;
      });
    }


    if (orderIds) {
      const ids = orderIds.split(",").map((id) => id.trim());
      filteredOrders = filteredOrders.filter(
        (order) => order.orderId && ids.includes(order.orderId.toString())
      );
    }

    if (awbNumbers) {
      const awbs = awbNumbers.split(",").map((awb_number) => awb_number.trim());
      filteredOrders = filteredOrders.filter(
        (order) =>
          order.awb_number && awbs.includes(order.awb_number.toString())
      );
    }

    if (productName) {
      filteredOrders = filteredOrders.filter((order) =>
        order.productDetails?.some(
          (product) =>
            product.name &&
            product.name.toLowerCase().includes(productName.toLowerCase())
        )
      );
    }

    if (channel) {
      filteredOrders = filteredOrders.filter(
        (order) =>
          order.channel && order.channel.toLowerCase() === channel.toLowerCase()
      );
    }

    if (type) {
      filteredOrders = filteredOrders.filter(
        (order) =>
          order.paymentDetails?.method &&
          order.paymentDetails.method.toLowerCase() === type.toLowerCase()
      );
    }

    if (courier) {
      filteredOrders = filteredOrders.filter(
        (order) =>
          order.courierServiceName &&
          order.courierServiceName.toLowerCase() === courier.toLowerCase()
      );
    }

    if (warehouse) {
      filteredOrders = filteredOrders.filter(
        (order) =>
          order.pickupAddress?.city &&
          order.pickupAddress.city.toLowerCase() === warehouse.toLowerCase()
      );
    }

    setFilteredOrders(filteredOrders);
    setShowFilters(false); // Close filters after applying
    setFiltersApplied(true); // Show red cross & red border
  };

  const clearFilters = () => {
    setFromDate("");
    setOrderIds("");
    setAwbNumbers("");
    setProductName("");
    setChannel("");
    setType("");
    setCourier("");
    setWarehouse("");
    setFilteredOrders(orders); // Reset to original orders
    setFiltersApplied(false);

    // Reset Date Filter
    setSelectionRange({
      startDate: null,
      endDate: null,
      key: "selection",
    });

    setStartDate(null);
    setEndDate(null);
    setDateFilter(""); // Reset dropdown to "Select Date Range"
  };


  // Ensure filters are NOT applied on first load/refresh
  useEffect(() => {
    setFiltersApplied(false); // Reset filters on refresh
  }, [refresh]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".mobile-dropdown")) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const renderTabContent = () => {
    switch (activeTab) {
      case "New":
        return <Orders orders={filteredOrders} />;
      case "Ready to Ship":
        return <ReadyToShipOrders orders={filteredOrders} />;
      case "In Transit":
        return <InTransitOrders orders={filteredOrders} />;
      case "Out for Delivery":
        return <OutForDelivery orders={filteredOrders} />;
      case "Delivered":
        return <DeliveredOrders orders={filteredOrders} />;
      case "Cancelled":
        return <CancelledOrder orders={filteredOrders} />;
      case "RTO":
        return <RTO orders={filteredOrders} />;
      case "RTO In Transit":
        return <RTOIntransit orders={filteredOrders} />;
      case "RTO Delivered":
        return <RTODelivered orders={filteredOrders} />;
      case "RTO Lost":
        return <RTOLost orders={filteredOrders} />;
      case "RTO Damaged":
        return <RTODamaged orders={filteredOrders} />;
      case "Lost":
        return <Lost orders={filteredOrders} />;
      case "Damaged":
        return <Damaged orders={filteredOrders} />;
      case "All":
        return <AllOrder orders={filteredOrders} />;
      default:
        return <div>Select a tab to view orders.</div>;
    }
  };

  //this is for date range picker
  const handleDateSuggestion = (value) => {
    let startDate, endDate;
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to the start of the day

    switch (value) {
      case "today":
        startDate = new Date(today);
        endDate = new Date(today);
        break;

      case "yesterday":
        startDate = new Date(today);
        startDate.setDate(startDate.getDate() - 1);
        endDate = new Date(startDate);
        break;

      case "last7days":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 6); // 6 days before today (including today)
        endDate = new Date(today);
        break;

      case "thismonth":
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        endDate = new Date(today);
        break;

      case "lastmonth":
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0); // Last day of the previous month
        break;

      case "thisyear":
        startDate = new Date(today.getFullYear(), 0, 1);
        endDate = new Date(today);
        break;

      case "custom":
        setShowCustomCalendar(true); // Open the calendar for custom selection
        return; // Exit early

      default:
        return;
    }

    // Update state properly
    setSelectionRange({ startDate, endDate, key: "selection" });
    setStartDate(startDate);
    setEndDate(endDate);
    setShowCustomCalendar(false); // Close the calendar for predefined options
  };

  const applyDateFilter = (dateRange) => {
    const { startDate, endDate } = dateRange;
    setFromDate(startDate);
    setEndDate(endDate);

    // Apply filter logic based on startDate and endDate
  };

  const getToday = () => {
    const today = new Date();
    return { startDate: today, endDate: today };
  };

  const getYesterday = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return { startDate: yesterday, endDate: yesterday };
  };

  const getLast7Days = () => {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 6); // 7 days ago
    return { startDate: sevenDaysAgo, endDate: today };
  };

  const getThisMonth = () => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    return { startDate: firstDayOfMonth, endDate: today };
  };

  const getThisYear = () => {
    const today = new Date();
    const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
    return { startDate: firstDayOfYear, endDate: today };
  };
  const handleDateChange = (ranges) => {
    setSelectionRange(ranges.selection);
    setStartDate(ranges.selection.startDate);
    setEndDate(ranges.selection.endDate);
  };

  const handleSelect = (ranges) => {
    setStartDate(ranges.selection.startDate);
    setEndDate(ranges.selection.endDate);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        desktopDropdownRef.current &&
        !desktopDropdownRef.current.contains(event.target)
      ) {
        setShowMoreTabs(false);
      }

      if (
        mobileDropdownRef.current &&
        !mobileDropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowMoreTabs(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleBulkUpload = () => {
    setUpload(true);
  };
  return (
    <div className={`md:px-2 px-1 ${showModal ? "overflow-hidden" : ""}`}>
      {!id && (
        <div className="">
          <h1 className="text-[12px] md:text-[18px] font-[600] text-gray-700">Orders</h1>
        </div>
      )}

      {/* Tabs for larger screens */}
      <div className="flex flex-row justify-between items-center gap-4">
        <div className="hidden md:flex flex-wrap gap-2 relative">
          {/* Only show visible tabs, not the 'more' ones */}
          {tabs.filter(tab => !moreTabs.includes(tab)).map((tab) => (
            <button
              key={tab}
              className={`px-3 py-2 text-gray-700 text-[12px] rounded-lg font-[600] transition-all duration-200 ${activeTab === tab
                ? "bg-[#0CBB7D] text-white"
                : "bg-white text-gray-700 hover:bg-green-200"
                }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}

          {/* More Dropdown */}
          <div className="relative" ref={desktopDropdownRef}>
            <button
              onClick={() => setShowMoreTabs((prev) => !prev)}
              className={`px-3 py-2 text-gray-700 text-[12px] rounded-lg font-[600] transition-all duration-200 flex items-center gap-1 ${moreTabs.includes(activeTab)
                ? "bg-[#0CBB7D] text-white"
                : "bg-white text-gray-700 hover:bg-green-200"
                }`}
            >
              {moreTabs.includes(activeTab) ? activeTab : "More"}
              <ChevronDown className="w-4 h-4" />
            </button>

            {showMoreTabs && (
              <div className="absolute left-0 top-full mt-1 bg-white border border-green-200 rounded-md shadow-md z-50 w-40">
                {moreTabs.map((tab) => (
                  <button
                    key={tab}
                    onClick={() => {
                      setActiveTab(tab);
                      setShowMoreTabs(false);
                    }}
                    className={`w-full text-left px-3 text-gray-700 py-2 text-[12px] font-[600] transition hover:bg-green-100 ${activeTab === tab
                      ? "bg-gray-200 font-[600] text-gray-700"
                      : ""
                      }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* New Order + Filters */}
        <div className="flex items-center gap-2">
          <div
            className="hidden sm:flex flex-col items-center space-y-2"
            onClick={handleBulkUpload}
          >
            <label className="cursor-pointer flex items-center gap-2 text-white bg-[#0CBB7D] px-3 h-[34px] rounded-lg border-2 border-[#0CBB7D] transition text-[10px] sm:text-[12px] font-[600]">
              <FaUpload className="text-white bg-[#0CBB7D]" />
              <span className="hidden sm:inline">Upload</span>
            </label>
          </div>
          <div className="hidden md:flex md:w-auto w-full">
            <button
              onClick={handleNewOrderClick}
              className="px-3 py-2 bg-[#0CBB7D] text-white rounded-lg text-[12px] font-[600]"
            >
              + New Order
            </button>
          </div>

        </div>
      </div>

      <div
        className={`overflow-hidden transition-max-height duration-700 ease-in-out ${showFilters ? "max-h-[600px]" : "max-h-0"
          }`}
      >
        <div className="bg-white shadow-md py-3 border-t border-gray-300">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-3 items-end">
            {/* Suggestions dropdown */}
            <select
              className="w-full p-1.5 text-sm border rounded-md focus:outline-none"
              value={dateFilter}
              onChange={(e) => {
                setDateFilter(e.target.value); // ✅ Update selected filter
                handleDateSuggestion(e.target.value); // ✅ Call function
              }}
            >
              <option value="">Select Date Range</option>
              <option value="today">Today</option>
              <option value="yesterday">Yesterday</option>
              <option value="last7days">Last 7 Days</option>
              <option value="thismonth">This Month</option>
              <option value="lastmonth">Last Month</option>
              <option value="thisyear">This Year</option>
              <option value="custom">Custom Range</option>
            </select>

            {/* Calendar picker for custom range */}
            {showCustomCalendar && (
              <div className="absolute bg-white border rounded-lg shadow-md p-2 mt-2 z-50 w-[90%] max-w-md sm:w-full overflow-hidden">
                <div className="overflow-x-auto max-w-full">
                  <DateRangePicker
                    ranges={[selectionRange]}
                    onChange={handleDateChange}
                    showSelectionPreview={true}
                    moveRangeOnFirstSelection={false}
                    className="text-xs sm:text-base"
                  />
                </div>
                <button
                  className="mt-2 px-3 py-1 text-xs bg-blue-500 text-white rounded-md w-full sm:w-auto sm:text-sm sm:px-6 sm:py-2"
                  onClick={() => setShowCustomCalendar(false)}
                >
                  Apply
                </button>
                <button
                  className="mt-2 ms-2 px-3 py-1 text-xs bg-blue-500 text-white rounded-md w-full sm:w-auto sm:text-sm sm:px-6 sm:py-2"
                  onClick={() => setShowCustomCalendar(false)}
                >
                  Cancel
                </button>
              </div>
            )}

            <input
              type="text"
              placeholder="Order IDs"
              className="w-full p-1.5 text-sm border rounded-md focus:outline"
              value={orderIds}
              onChange={(e) => setOrderIds(e.target.value)}
            />
            <input
              type="text"
              placeholder="AWB Numbers"
              className="w-full p-1.5 text-sm border rounded-md focus:outline"
              value={awbNumbers}
              onChange={(e) => setAwbNumbers(e.target.value)}
            />
            <input
              type="text"
              placeholder="Product Name"
              className="w-full p-1.5 text-sm border rounded-md focus:outline"
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
            />

            {/* Dropdown for Type */}
            <select
              className="w-full p-1.5 text-sm border rounded-md focus:outline-none"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="">Select Type</option>
              <option value="Prepaid">Prepaid</option>
              <option value="COD">COD</option>
            </select>

            <select
              className="w-full p-1.5 text-sm border rounded-md focus:outline-none"
              value={channel}
              onChange={(e) => setChannel(e.target.value)}
            >
              <option value="">Select Channel</option>
              <option value="custom">Custom Orders</option>
            </select>

            {/* Extract unique couriers from orders */}
            <select
              className="w-full p-1.5 text-sm border rounded-md focus:outline-none"
              value={courier}
              onChange={(e) => setCourier(e.target.value)}
              disabled={activeTab !== "Delivered" && activeTab !== "All" && activeTab !== "Cancelled" && activeTab !== "In Transit" && activeTab !== "Ready to Ship"}
            >
              <option value="">Select Courier</option>
              {Array.from(
                new Set(orders.map((order) => order.courierServiceName))
              )
                .filter(Boolean) // Remove empty values
                .map((courier, index) => (
                  <option key={index} value={courier}>
                    {courier}
                  </option>
                ))}
            </select>

            {/* Dropdown for Warehouse */}
            <select
              className="w-full p-1.5 text-sm border rounded-md focus:outline-none"
              value={warehouse}
              onChange={(e) => setWarehouse(e.target.value)}
            >
              <option value="">Select Pickup Address</option>
              {warehouseCities.map((city, index) => (
                <option key={index} value={city}>
                  {city}
                </option>
              ))}
            </select>

            {/* Apply Button in 4th Column */}
            <div className="md:col-start-4">
              <button
                className="bg-[#0CBB7D] text-white px-4 py-2 text-sm rounded-md w-full"
                onClick={applyFilters}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>


      {/* Mobile Dropdown for Tabs */}

      <div className="sm:hidden flex gap-2 w-full relative mb-2" ref={mobileDropdownRef}>
        {/* Dropdown Button Wrapper */}
        <div className="w-4/5">
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="w-full flex font-[600] justify-between items-center px-3 py-2 border border-gray-300 rounded-lg bg-[#0CBB7D] text-[10px] text-white"
          >
            {activeTab}
            <ChevronDown className="w-3 h-3 ml-2" />
          </button>

          {dropdownOpen && (
            <div className="absolute left-0 top-full mt-1 w-3/5 bg-white border rounded shadow-md z-[100] max-h-60 overflow-y-auto">
              {/* Main tabs */}
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`w-full flex text-left px-3 py-2 font-[600] text-[10px] ${activeTab === tab ? "bg-green-100" : "hover:bg-green-50"
                    }`}
                  onClick={() => {
                    setActiveTab(tab);
                    setDropdownOpen(false);
                  }}
                >
                  {tab}
                </button>
              ))}

              {/* Divider */}
              <div className="border-t border-gray-200 my-1" />

              {/* More tabs */}
              {moreTabs.map((tab) => (
                <button
                  key={tab}
                  className={`w-full font-[600] text-left px-3 py-2 text-[10px] ${activeTab === tab ? "bg-green-100 font-[600]" : "hover:bg-green-50"
                    }`}
                  onClick={() => {
                    setActiveTab(tab);
                    setDropdownOpen(false);
                  }}
                >
                  {tab}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* New Order Button Wrapper */}
        <div className="w-1/2">
          <button
            onClick={handleNewOrderClick}
            className="w-full px-3 py-2 bg-[#0CBB7D] text-white rounded-lg text-[10px] font-[600]"
          >
            + New Order
          </button>
        </div>
        <div
          className="flex flex-col items-center space-y-2"
          onClick={handleBulkUpload}
        >
          <label className="cursor-pointer flex items-center gap-2 text-white bg-[#0CBB7D] px-3 h-[30px] rounded-lg border-2 border-[#0CBB7D] transition text-[10px] sm:text-[12px] font-[600]">
            <FaUpload className="text-white bg-[#0CBB7D]" />
            <span className="hidden sm:inline">Upload</span>
          </label>
        </div>
      </div>




      {/* Search and Actions */}


      {/* Modal for KYC Incomplete */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center z-[70] p-2">
          {/* Background overlay */}
          <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>

          {/* Modal Content */}
          <div className="relative bg-white rounded-lg p-6 max-w-md w-full shadow-lg">
            <p className="text-lg font-medium mb-4 text-center">
              Your KYC is incomplete, please complete your KYC to create a new
              order.
            </p>
            <div className="flex justify-center gap-4">
              <button
                className="px-6 py-2 bg-[#0CBB7D] text-white rounded-lg text-sm md:text-base"
                onClick={() => {
                  navigate("/kyc");
                  setShowModal(false);
                }}
              >
                OK
              </button>
              <button
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg text-sm md:text-base"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Tab Content */}
      <div className="overflow-x-auto">{renderTabContent()}</div>
      {upload && (
        <BulkUploadPopup
          onClose={() => setUpload(false)}
          setRefresh={setRefresh}

        />
      )}
    </div>
  );
};

export default OrdersPage;